import React, { Component, PropTypes } from 'react';

class GWESliderCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    let name = this.props.name;
    let date = this.props.date;
    let imgUrl = this.props.imgUrl;
    let url = 'https://www.girlsworldexpo.com';

    return(
      <div className="festival-gweSliderCardWrapper">
        <a target="_blank" href={url}><div className="festival-gweSliderCard">
          <div className="festival-gweSliderImg">
            <img src={imgUrl} />
          </div>
          <div className="festival-gweSliderOverlay">
            <div className="festival-gweSliderName">
              {name}
            </div>
            <div className="festival-gweSliderDate">
              {date}
            </div>
          </div>
        </div></a>
      </div>
    );
  }
}

export default GWESliderCard;



// WEBPACK FOOTER //
// ./src/components/festival/gwe/GWESliderCard.jsx